import { PawPrint, Share2 } from "lucide-react";
import shareCardBg from "@/assets/share-card-bg.png";

interface Props {
  backgroundDataUrl?: string;
}

/**
 * Story 1: Minimalistyczny - duży tekst główny, dużo przestrzeni
 */
export const InstagramStoryShare1 = ({ backgroundDataUrl }: Props) => {
  const bgImage = backgroundDataUrl || shareCardBg;

  return (
    <div
      style={{
        width: "1080px",
        height: "1920px",
        fontFamily: "'Nunito', sans-serif",
        display: "flex",
        flexDirection: "column",
        position: "relative",
        overflow: "hidden",
        backgroundColor: "#1a3a2a",
      }}
    >
      {/* Background image */}
      <img
        src={bgImage}
        alt=""
        draggable={false}
        data-export-bg="true"
        loading="eager"
        decoding="sync"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: 0,
        }}
      />

      {/* Top decorative bar */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: "8px",
          background: "linear-gradient(90deg, #4E8A6E 0%, #6BAF8D 50%, #4E8A6E 100%)",
          zIndex: 2,
        }}
      />

      {/* Content */}
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "280px 80px",
          position: "relative",
          zIndex: 1,
        }}
      >
        {/* Main headline with heart */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            marginBottom: "64px",
          }}
        >
          <h1
            style={{
              fontSize: "96px",
              fontWeight: 800,
              color: "#2D5A3D",
              margin: 0,
              lineHeight: 1.1,
            }}
          >
            Udostępnienie
          </h1>
          <h1
            style={{
              fontSize: "96px",
              fontWeight: 800,
              color: "#2D5A3D",
              margin: 0,
              lineHeight: 1.1,
            }}
          >
            też pomaga 💚
          </h1>
        </div>

        {/* Subtext */}
        <p
          style={{
            fontSize: "44px",
            fontWeight: 600,
            color: "#4A7A5E",
            margin: "0 0 72px",
            textAlign: "center",
            lineHeight: 1.5,
            maxWidth: "900px",
          }}
        >
          Może ktoś z Twoich znajomych
          <br />
          chce pomóc, tylko nie wie jak.
        </p>

        {/* Community message */}
        <div
          style={{
            background: "rgba(255,255,255,0.95)",
            borderRadius: "32px",
            padding: "36px 56px",
            boxShadow: "0 8px 32px rgba(0,0,0,0.08)",
            marginBottom: "80px",
          }}
        >
          <p
            style={{
              fontSize: "36px",
              fontWeight: 700,
              color: "#2D5A3D",
              margin: 0,
              textAlign: "center",
              lineHeight: 1.4,
            }}
          >
            Zbudujmy razem społeczność
            <br />
            pomagającą schroniskom
          </p>
        </div>

        {/* CTA */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "16px",
          }}
        >
          <Share2 style={{ width: "40px", height: "40px", color: "#4E8A6E" }} />
          <span
            style={{
              fontSize: "40px",
              fontWeight: 700,
              color: "#4E8A6E",
            }}
          >
            Udostępnij dalej
          </span>
        </div>
      </div>

      {/* Footer */}
      <div
        style={{
          padding: "0 80px 100px",
          display: "flex",
          justifyContent: "center",
          position: "relative",
          zIndex: 1,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "16px",
          }}
        >
          <div
            style={{
              background: "#4E8A6E",
              borderRadius: "16px",
              width: "56px",
              height: "56px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <PawPrint style={{ width: "32px", height: "32px", color: "#FFFFFF" }} />
          </div>
          <span style={{ fontSize: "32px", fontWeight: 800, color: "#2D5A3D" }}>
            gdzieschronisko.pl
          </span>
        </div>
      </div>
    </div>
  );
};
